/* stylelint-disable */
import { css, SerializedStyles } from '@emotion/react';

export const intercomChatStyle = (isCasino: boolean): SerializedStyles => css`
    .intercom-lightweight-app-launcher, .intercom-namespace [class^="intercom-with-namespace-"] {
        bottom: ${isCasino ? '65px !important' : '100px !important'};
        z-index: 1 !important;

        @media(min-width: 1024px){
            bottom: 20px !important;
            z-index: 11 !important;
        }
    }

    .intercom-lightweight-app {
        z-index: 1 !important;

        @media(min-width: 1024px){
            z-index: 11 !important;
        }
    }

    .intercom-messenger-frame  {
        bottom: ${isCasino ? '124px !important' : '164px !important'};
        @media(min-width: 1024px){
            bottom: 84px !important;
        }
    }
`;
